/* Pet Splash — minimal progressive enhancement. No dependencies. */
(function () {
  'use strict';

  /* ---- Mobile menu -------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-ps-menu-toggle]');
    if (!toggle) return;
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    var open = panel.getAttribute('data-open') === 'true';
    panel.setAttribute('data-open', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  document.addEventListener('click', function (event) {
    var deleteLink = event.target.closest('[data-method="delete"]');
    if (deleteLink) {
      event.preventDefault();
      if (!window.confirm(deleteLink.getAttribute('data-confirm-message') || 'Delete this item?')) return;
      var deleteForm = document.createElement('form');
      deleteForm.method = 'post';
      deleteForm.action = deleteLink.getAttribute('data-target') || deleteLink.href;
      var method = document.createElement('input');
      method.type = 'hidden'; method.name = '_method'; method.value = 'delete';
      deleteForm.appendChild(method); document.body.appendChild(deleteForm); deleteForm.submit();
      return;
    }

    var checkout = event.target.closest('[name="checkout"]');
    if (checkout && window.PetSplashTracking) {
      window.PetSplashTracking.track('InitiateCheckout', { currency: document.documentElement.getAttribute('data-currency') || undefined });
    }
  });

  /* ---- Variant picker ----------------------------------------------- */
  function initVariantPickers(root) {
    root.querySelectorAll('[data-ps-variants]').forEach(function (picker) {
      var scopeId = picker.getAttribute('data-ps-variants');
      var scope = document.querySelector('[data-ps-buy="' + scopeId + '"]') || document;

      var matrixNode = picker.querySelector('[data-ps-variant-matrix]');
      if (matrixNode) {
        var variants = [];
        try { variants = JSON.parse(matrixNode.textContent); } catch (error) { variants = []; }

        function selectMatrixVariant() {
          var selectedOptions = Array.from(picker.querySelectorAll('[data-ps-option-position]')).map(function (group) {
            var selected = group.querySelector('[data-ps-option-value]:checked');
            return selected ? selected.value : null;
          });
          if (selectedOptions.some(function (value) { return value === null; })) return;

          var variant = variants.find(function (candidate) {
            return candidate.options.length === selectedOptions.length && candidate.options.every(function (value, index) {
              return value === selectedOptions[index];
            });
          });
          if (!variant) return;

          var idField = scope.querySelector('[data-ps-variant-id]');
          if (idField) {
            var petSelection = picker.querySelector('[data-ps-option-position="2"] [data-ps-option-value]:checked');
            idField.value = variant.id;
            idField.setAttribute('data-price-cents', variant.price);
            idField.setAttribute('data-title', variant.title);
            idField.setAttribute('data-url', variant.url);
            idField.setAttribute('data-available', variant.available);
            idField.setAttribute('data-pet-count', petSelection ? petSelection.getAttribute('data-pet-count') : petCount(selectedOptions[selectedOptions.length - 1]));
          }

          scope.querySelectorAll('[data-ps-price]').forEach(function (node) {
            node.textContent = variant.priceFormatted;
          });
          scope.querySelectorAll('[data-ps-variant-title]').forEach(function (node) {
            node.textContent = variant.title;
          });
          scope.querySelectorAll('[data-ps-submit]').forEach(function (button) {
            button.disabled = !variant.available;
            button.textContent = variant.available
              ? button.getAttribute('data-label-available')
              : button.getAttribute('data-label-soldout');
          });

          updateExtraUploads(scope, idField);
          if (history.replaceState && variant.url) {
            try { history.replaceState({}, '', variant.url); } catch (error) {}
          }
        }

        picker.addEventListener('change', function (event) {
          if (event.target.matches('[data-ps-option-value]')) selectMatrixVariant();
        });
        selectMatrixVariant();
        return;
      }

      picker.addEventListener('change', function (event) {
        var input = event.target.closest('input[type="radio"]');
        if (!input) return;

        var price = input.getAttribute('data-price') || '';
        var available = input.getAttribute('data-available') === 'true';

        scope.querySelectorAll('[data-ps-price]').forEach(function (node) {
          node.textContent = price;
        });

        scope.querySelectorAll('[data-ps-variant-title]').forEach(function (node) {
          node.textContent = input.getAttribute('data-title') || '';
        });

        scope.querySelectorAll('[data-ps-submit]').forEach(function (button) {
          button.disabled = !available;
          button.textContent = available
            ? button.getAttribute('data-label-available')
            : button.getAttribute('data-label-soldout');
        });

        var idField = scope.querySelector('[data-ps-variant-id]');
        if (idField) idField.value = input.value;

        if (history.replaceState && input.getAttribute('data-url')) {
          try { history.replaceState({}, '', input.getAttribute('data-url')); } catch (error) {}
        }

        updateExtraUploads(scope, input);
      });

      var selected = picker.querySelector('input[type="radio"]:checked');
      if (selected) updateExtraUploads(scope, selected);
    });
  }

  /* ---- File uploads ------------------------------------------------- */
  var MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
  var DOWNSCALE_MAX_DIM = 2400;

  function looksLikeImage(file) {
    if (file.type) return /^image\//.test(file.type);
    return /\.(jpe?g|png|gif|webp|heic|heif|bmp|tiff?)$/i.test(file.name || '');
  }

  function petCount(title) {
    var value = String(title || '').toLowerCase();
    var match = value.match(/(\d+)\s*pet/);
    if (match) return Math.max(1, Math.min(4, parseInt(match[1], 10)));
    var words = { one: 1, two: 2, three: 3, four: 4 };
    for (var word in words) {
      if (new RegExp('(?:up to\\s+)?' + word + '\\s+pets?').test(value)) return words[word];
    }
    return 1;
  }

  function updateExtraUploads(scope, variantInput) {
    var wrap = scope.querySelector('[data-ps-extra-uploads]');
    if (!wrap) return;
    var explicitCount = variantInput && parseInt(variantInput.getAttribute('data-pet-count'), 10);
    var count = explicitCount || petCount(variantInput && variantInput.getAttribute('data-title'));
    wrap.hidden = count < 2;
    wrap.querySelectorAll('[data-ps-upload-slot]').forEach(function (slot) {
      var number = parseInt(slot.getAttribute('data-ps-upload-slot'), 10);
      var show = number <= count;
      slot.hidden = !show;
      var input = slot.querySelector('input[type="file"]');
      if (input) input.required = show;
      if (!show) {
        var preview = slot.querySelector('[data-ps-upload-preview]');
        var status = slot.querySelector('[data-ps-upload-status]');
        if (input) input.value = '';
        if (preview) preview.hidden = true;
        if (status) status.textContent = status.getAttribute('data-default') || '';
      }
    });
  }

  function resizeImage(input, file) {
    return new Promise(function (resolve, reject) {
      if (!window.FileReader || !window.File || !window.DataTransfer) return reject(new Error('unsupported'));
      var reader = new FileReader();
      reader.onerror = reject;
      reader.onload = function (event) {
        var image = new Image();
        image.onerror = reject;
        image.onload = function () {
          try {
            var scale = Math.min(1, DOWNSCALE_MAX_DIM / Math.max(image.width, image.height));
            var canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.round(image.width * scale));
            canvas.height = Math.max(1, Math.round(image.height * scale));
            canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
            canvas.toBlob(function (blob) {
              if (!blob) return reject(new Error('resize'));
              var name = (file.name || 'pet-photo').replace(/\.(heic|heif|bmp|tiff?)$/i, '');
              if (!/\.jpe?g$/i.test(name)) name += '.jpg';
              var resized = new File([blob], name, { type: 'image/jpeg' });
              var transfer = new DataTransfer();
              transfer.items.add(resized);
              input.files = transfer.files;
              resolve(resized);
            }, 'image/jpeg', 0.9);
          } catch (error) { reject(error); }
        };
        image.src = event.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  function showUpload(input, file) {
    var field = input.closest('[data-ps-upload]');
    var status = field && field.querySelector('[data-ps-upload-status]');
    var preview = field && field.querySelector('[data-ps-upload-preview]');
    var image = preview && preview.querySelector('img');
    var error = field && field.querySelector('[data-ps-upload-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
    if (status) status.textContent = file.name + ' — ready to send';
    if (image && window.FileReader) {
      var reader = new FileReader();
      reader.onload = function (event) { image.src = event.target.result; preview.hidden = false; };
      reader.readAsDataURL(file);
    }
  }

  function initUploads(root) {
    root.querySelectorAll('[data-ps-upload] input[type="file"]').forEach(function (input) {
      if (input.getAttribute('data-ps-wired')) return;
      input.setAttribute('data-ps-wired', 'true');
      input.addEventListener('change', function () {
        var field = input.closest('[data-ps-upload]');
        var error = field && field.querySelector('[data-ps-upload-error]');
        var file = input.files && input.files[0];
        if (!file) return;
        if (!looksLikeImage(file)) {
          input.value = '';
          if (error) { error.textContent = 'That file does not look like a photo. Please choose an image.'; error.hidden = false; }
          return;
        }
        if (file.size > MAX_UPLOAD_BYTES) {
          if (error) { error.textContent = 'That photo is large — resizing it for you…'; error.hidden = false; }
          resizeImage(input, file).then(function (resized) {
            showUpload(input, resized);
          }).catch(function () {
            input.value = '';
            if (error) { error.textContent = 'That photo is over 25MB and could not be resized. Please choose a smaller image.'; error.hidden = false; }
          });
          return;
        }
        showUpload(input, file);

        if (input.hasAttribute('required') && window.PetSplashTracking && !input.dataset.photoEventSent) {
          input.dataset.photoEventSent = 'true';
          var scope = input.closest('[data-ps-buy]');
          var variant = scope && scope.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
          window.PetSplashTracking.track('PhotoAttached', {
            content_ids: variant ? [String(variant.value)] : undefined,
            content_type: 'product_variant',
            content_name: scope ? scope.getAttribute('data-product-title') : undefined,
            currency: scope ? scope.getAttribute('data-currency') : undefined
          }, { custom: true });
        }
      });
    });
  }

  /* ---- Personalised order submit ----------------------------------- */
  function initBuyForms(root) {
    root.querySelectorAll('[data-ps-buy] form').forEach(function (form) {
      if (form.getAttribute('data-ps-submit-wired')) return;
      form.setAttribute('data-ps-submit-wired', 'true');
      var scope = form.closest('[data-ps-buy]');
      var submitting = false;

      form.addEventListener('submit', function (event) {
        if (submitting) { event.preventDefault(); return; }
        var photo = form.querySelector('input[type="file"][required]');
        if (photo && (!photo.files || !photo.files.length)) {
          event.preventDefault();
          var field = photo.closest('[data-ps-upload]');
          var error = field && field.querySelector('[data-ps-upload-error]');
          if (error) { error.textContent = 'Please add your pet photo before continuing.'; error.hidden = false; }
          if (field && field.scrollIntoView) field.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        var variant = form.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
        if (window.PetSplashTracking && variant) {
          window.PetSplashTracking.track('AddToCart', {
            content_ids: [String(variant.value)],
            content_type: 'product_variant',
            content_name: scope.getAttribute('data-product-title'),
            value: Number(variant.getAttribute('data-price-cents') || 0) / 100,
            currency: scope.getAttribute('data-currency')
          });
        }

        if (scope.getAttribute('data-single-order-cart') !== 'true' || !window.fetch) return;
        event.preventDefault();
        submitting = true;
        form.querySelectorAll('[type="submit"]').forEach(function (button) { button.disabled = true; });
        fetch('/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
        }).then(function () { form.submit(); }).catch(function () { form.submit(); });
      });
    });
  }

  /* ---- Product media gallery ---------------------------------------- */
  function initMedia(root) {
    root.querySelectorAll('[data-ps-media]').forEach(function (gallery) {
      var main = gallery.querySelector('.ps-media__main img');
      if (!main) return;
      gallery.querySelectorAll('[data-ps-media-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.getAttribute('data-src');
          main.srcset = thumb.getAttribute('data-srcset') || '';
          main.alt = thumb.getAttribute('data-alt') || '';
          gallery.querySelectorAll('[data-ps-media-thumb]').forEach(function (other) {
            other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ---- Sticky mobile add-to-cart ------------------------------------ */
  function initStickyBuy(root) {
    var bar = root.querySelector('[data-ps-sticky-buy]');
    var anchor = root.querySelector('[data-ps-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
        });
      },
      { rootMargin: '-140px 0px 0px 0px' }
    );

    observer.observe(anchor);
  }

  /* ---- External review feed ---------------------------------------- */
  function initReviews(root) {
    root.querySelectorAll('[data-ps-live-reviews]').forEach(function (section) {
      if (section.dataset.loaded === 'true') return;
      section.dataset.loaded = 'true';
      var list = section.querySelector('[data-ps-review-list]');
      var summary = section.querySelector('[data-ps-review-summary]');
      fetch(section.getAttribute('data-feed'), { headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('reviews'); return response.json(); })
        .then(function (payload) {
          var reviews = Array.isArray(payload) ? payload : (payload.reviews || []);
          list.innerHTML = '';
          reviews.slice(0, 6).forEach(function (review) {
            var card = document.createElement('article');
            card.className = 'ps-card ps-review-card';
            if (review.portrait) {
              var image = document.createElement('img');
              image.src = review.portrait; image.alt = (review.pet || 'Pet') + ' portrait'; image.loading = 'lazy';
              card.appendChild(image);
            }
            var stars = document.createElement('p');
            stars.className = 'ps-review-card__stars';
            stars.setAttribute('aria-label', (review.rating || 5) + ' out of 5 stars');
            stars.textContent = '★★★★★'; card.appendChild(stars);
            var quote = document.createElement('blockquote'); quote.textContent = review.text || review.review || ''; card.appendChild(quote);
            var byline = document.createElement('p'); byline.textContent = review.name || review.customer || ''; card.appendChild(byline);
            list.appendChild(card);
          });
          list.setAttribute('aria-busy', 'false');
          if (summary && reviews.length) {
            var total = reviews.reduce(function (sum, review) { return sum + Number(review.rating || 5); }, 0);
            summary.textContent = (total / reviews.length).toFixed(1) + ' out of 5 from ' + reviews.length + ' reviews';
            summary.hidden = false;
          }
        }).catch(function () {
          if (list) { list.innerHTML = ''; list.setAttribute('aria-busy', 'false'); }
        });
    });
  }

  /* ---- Cart companion-product upsell ------------------------------- */
  function initCartUpsells(root) {
    root.querySelectorAll('[data-ps-cart-upsell]').forEach(function (box) {
      if (box.dataset.wired === 'true') return;
      box.dataset.wired = 'true';
      var button = box.querySelector('[data-ps-upsell-add]');
      var status = box.querySelector('[data-ps-upsell-status]');
      if (!button) return;
      button.addEventListener('click', function () {
        var variantId = Number(box.getAttribute('data-variant-id'));
        if (!variantId || button.disabled) return;
        var originalLabel = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';
        if (status) status.textContent = '';

        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); })
          .then(function (cart) {
            var portrait = (cart.items || []).find(function (item) { return Number(item.variant_id) !== variantId; });
            if (!portrait) throw new Error('portrait');
            var properties = Object.assign({}, portrait.properties || {}, {
              _ps_companion_upgrade: 'true',
              _ps_parent_variant: String(portrait.variant_id)
            });
            return fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('add');
            if (status) status.textContent = 'Added — updating your cart.';
            window.location.reload();
          })
          .catch(function () {
            button.disabled = false;
            button.textContent = originalLabel;
            if (status) status.textContent = 'We could not add that just now. Please try again.';
          });
      });
    });
  }

  function initRecommendations(root) {
    root.querySelectorAll('[data-ps-recommendations]').forEach(function (section) {
      if (section.dataset.loaded === 'true' || section.querySelector('.ps-related-products')) return;
      section.dataset.loaded = 'true';
      fetch(section.getAttribute('data-url'))
        .then(function (response) { if (!response.ok) throw new Error('recommendations'); return response.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var replacement = parsed.querySelector('[data-ps-recommendations]');
          if (replacement && replacement.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
        }).catch(function () {});
    });
  }

  function initBeforeAfter(root) {
    root.querySelectorAll('[data-ps-before-after]').forEach(function (slider) {
      var range = slider.querySelector('input[type="range"]');
      if (!range || range.dataset.wired === 'true') return;
      range.dataset.wired = 'true';
      var update = function () { slider.style.setProperty('--ps-split', range.value + '%'); };
      range.addEventListener('input', update); update();
    });
  }

  function init(root) {
    root.querySelectorAll('select[data-default]').forEach(function (select) {
      var value = select.getAttribute('data-default');
      if (value) select.value = value;
    });
    initVariantPickers(root);
    initUploads(root);
    initBuyForms(root);
    initMedia(root);
    initStickyBuy(root);
    initReviews(root);
    initCartUpsells(root);
    initRecommendations(root);
    initBeforeAfter(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Re-run inside the theme editor when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
